import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import Seo from "@/components/Seo";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { ArchitectureMatrix } from "@/components/ArchitectureMatrix";
import { EditorialMarquee } from "@/components/Marquee";
import { Manifesto } from "@/components/Manifesto";
import { Resiliency } from "@/components/Resiliency";
import { NodeMap } from "@/components/NodeMap";
import { CapitalStack } from "@/components/CapitalStack";
import { DataRoom } from "@/components/DataRoom";
import { Footer } from "@/components/Footer";
import Compliance from "@/pages/Compliance";

const Home = () => {
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1.05 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="bg-[#0A0A0A] text-white min-h-screen">
      <Seo
        title="Equinox Infrastructure Holdings — Project Equinox"
        siteName="Equinox Infrastructure Holdings"
        description="Autonomous 10 MW off-grid enclosure tranches with zero-fault connectivity and orbital satellite shielding for institutional counterparties."
        image="/hero-enclosure.jpg"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "Organization",
          name: "Equinox Infrastructure Holdings, LLC",
          description:
            "Autonomous 10 MW off-grid enclosure tranches for institutional counterparties.",
          email: "compliance@equinoxih.com",
        }}
      />
      <Nav onRequestAccess={() => setModalOpen(true)} />
      <main>
        <Hero />
        <ArchitectureMatrix />
        <EditorialMarquee />
        <Manifesto />
        <Resiliency />
        <NodeMap />
        <CapitalStack />
        <DataRoom open={modalOpen} setOpen={setModalOpen} />
      </main>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/compliance" element={<Compliance />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" />
    </div>
  );
}

export default App;
